import { createFileRoute } from '@tanstack/react-router'
import { edyStatisticsSearchSchema } from '@/features/edy-statistics/select-statistics-period/model/edyStatisticsSearch'
import { EdyStatisticsPage } from '@/pages/platform-users/ui/EdyStatisticsPage'

export const Route = createFileRoute('/statistics')({
  validateSearch: edyStatisticsSearchSchema,
  component: EdyStatisticsPage,
})
